export const USER_ROLES = {
    SUPER_ADMIN: "Super Admin",
    ADMIN: "Admin",
    BROKER_ADMIN: "Broker Admin",
    BROKER: "Broker",
    CLIENT: "Client",
}